import React, { PureComponent, useState, useEffect } from "react";
import RoutePath from "../../components/RoutePath";
import axios from "axios";
import { downloadGallery } from "../../components/UtilsGoat";
import { Link } from 'react-router-dom';

const GetImage = ({ image_name, label }) => {
  const [src, set_src] = useState("");

  useEffect(() => {
    console.log("getimage", image_name);
    downloadGallery(image_name).then((objectURL) => {
      set_src(objectURL);
    });
  }, []);

  return (
    <>
      {src == undefined ? (
        <div style={{ width: 422, padding: "0px 50px", margin: "0px 25px" }}>
          <img
            style={{ width: 300, height: 256, margin: "10px 24px" }}
            src={`/images/no-image.png`}
          />
          <p style={{ textAlign: "center" }}>{label}</p>
        </div>
      ) : (
        <div>
          <img
            style={{
              width: 422,
              height: 256,
              margin: "10px 24px",
            }}
            src={src}
          />
          <p style={{ textAlign: "center" }}>{label}</p>
        </div>
      )}
    </>
  );
};

class LandingPageQR extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      key: this.props.match.params.id,
      matches: window.matchMedia("(min-width: 768px)").matches,
      data: {},
      goat: {},
      goat_owner: [],
      image_father: "",
      image_mother: "",
      image_front: "",
      image_back: "",
      image_right: "",
      image_left: "",
    };
  }

  componentDidMount() {
    this.getGoatDetail();
    const handler = (e) => this.setState({ matches: e.matches });
    window.matchMedia("(min-width: 768px)").addEventListener("change", handler);
  }

  getGoatDetail = () => {
    if (!this.state.key) return;
    axios
      .get(
        `${process.env.REACT_APP_BASE_API_URL}gombekCertificate?key=${this.state.key}`
      )
      .then((res) => {
        this.setState({
          data: res.data.data,
          goat: res.data.data.goat,
          goat_owner: res.data.data.goat.goat_owner,
        });
        downloadGallery(res.data.data.goat.image_front).then((objectURL) => {
          this.setState({ image_front: objectURL });
        });
        downloadGallery(res.data.data.goat.image_back).then((objectURL) => {
          this.setState({ image_back: objectURL });
        });
        downloadGallery(res.data.data.goat.image_father).then((objectURL) => {
          this.setState({ image_father: objectURL });
        });
        downloadGallery(res.data.data.goat.image_mother).then((objectURL) => {
          this.setState({ image_mother: objectURL });
        });
        downloadGallery(res.data.data.goat.image_right).then((objectURL) => {
          this.setState({ image_right: objectURL });
        });
        downloadGallery(res.data.data.goat.image_left).then((objectURL) => {
          this.setState({ image_left: objectURL });
        });
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          console.log(error.response);
          this.props.history.push(RoutePath.GOAT_CARD);
        }
      });
  };

  render() {
    return (
      <>
        {this.state.matches ? (
          <div style={{ position: "relative", width: "100%", height: "auto" }}>
            <div
              style={{
                height: 520,
                width: "100%",
                backgroundColor: "#3D8F1E",
                position: "absolute",
                zIndex: -100,
              }}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                minWidth: 1180,
              }}
            >
              <div
                style={{
                  minWidth: 1180,
                  paddingTop: 40,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <img
                  src={`/images/gombek2.png`}
                  style={{
                    width: 116,
                    height: 106,
                  }}
                />
                <p
                  style={{
                    fontWeight: 600,
                    fontSize: 32,
                    lineHeight: "160%",
                    letterSpacing: "0.015em",
                    color: "#fff",
                  }}
                >
                  Gombekk Indonesia
                </p>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div
                style={{
                  marginBottom: 107,
                  marginTop: 24,
                  width: 1180,
                  display: "flex",
                  justifyContent: "center",
                  background: "#FDFFFC",
                  border: "3.5px solid #CECECE",
                  boxShadow: "8px 16px 24px rgba(124, 128, 122, 0.2)",
                  borderRadius: 24,
                }}
              >
                <div style={{ flexDirection: "column" }}>
                  <img
                    src={`/images/header.png`}
                    style={{
                      marginTop: 40,
                      width: 980,
                      height: 186,
                    }}
                  />
                  <hr style={{ border: "2px solid #000000", marginTop: -20 }} />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    <div style={{ width: "100%" }}>
                      <div
                        style={{
                          marginTop: 56,
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: 32,
                        }}
                      >
                        Informasi Data Kambing
                        <hr
                          style={{
                            marginLeft: 0,
                            width: 445,
                            border: "2px solid #000000",
                          }}
                        />
                      </div>
                      <div style={{ marginTop: 48 }}>
                        <div style={styles.textContainer}>
                          <p style={styles.text}>Nomor Sertifikat</p>
                          <p style={styles.textValue}>
                            : {this.state.data.code}
                          </p>
                        </div>
                        <div style={styles.textContainer}>
                          <p style={styles.text}>Nama Kambing</p>
                          <p style={styles.textValue}>
                            : {this.state.data?.goat?.full_name}
                          </p>
                        </div>
                        <div style={styles.textContainer}>
                          <p style={styles.text}>Ident</p>
                          <p style={styles.textValue}>
                            : {this.state.data?.goat?.identity_tag}
                          </p>
                        </div>
                        <div style={styles.textContainer}>
                          <p style={styles.text}>Tatto</p>
                          <p style={styles.textValue}>: -</p>
                        </div>
                        <div style={styles.textContainer}>
                          <p style={styles.text}>Sex</p>
                          <p
                            style={{
                              ...styles.textValue,
                              textTransform: "capitalize",
                            }}
                          >
                            : {this.state.data?.goat?.gender}
                          </p>
                        </div>
                        <div style={styles.textContainer}>
                          <p style={styles.text}>Grade</p>
                          <p style={styles.textValue}>
                            : {this.state.data?.goat?.grade?.name}
                          </p>
                        </div>
                        <div style={styles.textContainer}>
                          <p style={styles.text}>Colour</p>
                          <p style={styles.textValue}>
                            : {this.state.data?.goat?.color?.name}
                          </p>
                        </div>
                        <div style={styles.textContainer}>
                          <p style={styles.text}>Birth Weight</p>
                          <p style={styles.textValue}>
                            : {this.state.data?.goat?.weight} Kg
                          </p>
                        </div>
                        <div style={styles.textContainer}>
                          <p style={styles.text}>Birth Type</p>
                          <p style={styles.textValue}>
                            : {this.state.data?.goat?.goat_birth_type?.name}
                          </p>
                        </div>
                        <div style={styles.textContainer}>
                          <p style={styles.text}>BREEDER (PFA)</p>
                          <p style={styles.textValue}>: -</p>
                        </div>
                        {this.state.goat_owner.map((item) => {
                          return (
                            <>
                              <div style={styles.textContainer}>
                                <p style={styles.text}>OWNER (PFA)</p>
                                <p style={styles.textValue}>
                                  : {item.owner.name}
                                </p>
                              </div>
                            </>
                          );
                        })}
                      </div>

                      <div
                        style={{
                          marginTop: 48,
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: 32,
                        }}
                      >
                        Foto Kambing
                        <hr
                          style={{
                            marginLeft: 0,
                            width: 445,
                            border: "2px solid #000000",
                          }}
                        />
                        <div style={{ marginTop: 33 }}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              style={
                                !this.state.image_father
                                  ? styles.imageNotFound
                                  : null
                              }
                            >
                              <img
                                style={{
                                  width: this.state.image_father ? 422 : 300,
                                  height: 256,
                                  margin: "10px 24px",
                                }}
                                src={
                                  this.state.image_father
                                    ? this.state.image_father
                                    : `/images/no-image.png`
                                }
                              />
                              <p style={{ textAlign: "center" }}>Shire</p>
                            </div>

                            <div
                              style={
                                !this.state.image_mother
                                  ? styles.imageNotFound
                                  : null
                              }
                            >
                              <img
                                style={{
                                  width: this.state.image_mother ? 422 : 300,
                                  height: 256,
                                  margin: "10px 24px",
                                }}
                                src={
                                  this.state.image_mother
                                    ? this.state.image_mother
                                    : `/images/no-image.png`
                                }
                              />
                              <p style={{ textAlign: "center" }}>Dam</p>
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              style={
                                !this.state.image_front
                                  ? styles.imageNotFound
                                  : null
                              }
                            >
                              <img
                                style={{
                                  width: this.state.image_front ? 422 : 300,
                                  height: 256,
                                  margin: "10px 24px",
                                }}
                                src={
                                  this.state.image_front
                                    ? this.state.image_front
                                    : `/images/no-image.png`
                                }
                              />
                              <p style={{ textAlign: "center" }}>Front</p>
                            </div>

                            <div
                              style={
                                !this.state.image_back
                                  ? styles.imageNotFound
                                  : null
                              }
                            >
                              <img
                                style={{
                                  width: this.state.image_back ? 422 : 300,
                                  height: 256,
                                  margin: "10px 24px",
                                }}
                                src={
                                  this.state.image_back
                                    ? this.state.image_back
                                    : `/images/no-image.png`
                                }
                              />
                              <p style={{ textAlign: "center" }}>Back</p>
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              style={
                                !this.state.image_right
                                  ? styles.imageNotFound
                                  : null
                              }
                            >
                              <img
                                style={{
                                  width: this.state.image_right ? 422 : 300,
                                  height: 256,
                                  margin: "10px 24px",
                                }}
                                src={
                                  this.state.image_right
                                    ? this.state.image_right
                                    : `/images/no-image.png`
                                }
                              />
                              <p style={{ textAlign: "center" }}>Right</p>
                            </div>

                            <div
                              style={
                                !this.state.image_left
                                  ? styles.imageNotFound
                                  : null
                              }
                            >
                              <img
                                style={{
                                  width: this.state.image_left ? 422 : 300,
                                  height: 256,
                                  margin: "10px 24px",
                                }}
                                src={
                                  this.state.image_left
                                    ? this.state.image_left
                                    : `/images/no-image.png`
                                }
                              />
                              <p style={{ textAlign: "center" }}>Left</p>
                            </div>
                          </div>

                          <p style={{ textAlign: "center", marginTop: 60 }}>
                            Cetak Kartu Kambing
                          </p>
                          <Link
                            to={`${RoutePath.GOAT_CARD.replace(
                              ":id",
                              this.state.data?.goat_id
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <input
                              type="submit"
                              style={{
                                background: "#1C7406",
                                boxShadow: "0px 8px 8px #D8DDD7",
                                borderRadius: 8,
                                width: 339,
                                height: 64,
                                color: "white",
                                marginTop: 24,
                                cursor: "pointer",
                                marginBottom: 24,
                              }}
                              value="Cetak Kartu"
                            />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div style={{ position: "relative", width: "100%" }}>
            <div
              style={{
                height: 240,
                width: "100%",
                backgroundColor: "#3D8F1E",
                position: "absolute",
                zIndex: -100,
              }}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                minWidth: 343,
              }}
            >
              <div
                style={{
                  minWidth: 343,
                  paddingTop: 40,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <img
                  src={`/images/gombek2.png`}
                  style={{
                    width: 68,
                    height: 54,
                  }}
                />
                <p
                  style={{
                    fontWeight: 500,
                    fontSize: 20,
                    lineHeight: "160%",
                    letterSpacing: "0.015em",
                    color: "#fff",
                  }}
                >
                  Gombekk Indonesia
                </p>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div
                style={{
                  marginBottom: 56,
                  marginTop: 16,
                  width: 343,
                  display: "flex",
                  justifyContent: "center",
                  background: "#FDFFFC",
                  border: "2px solid #CECECE",
                  boxShadow: "8px 8px 16px rgba(124, 128, 122, 0.2)",
                  borderRadius: 8,
                }}
              >
                <div style={{ flexDirection: "column" }}>
                  <img
                    src={`/images/header.png`}
                    style={{
                      marginTop: 16,
                      width: 279,
                      height: 52,
                    }}
                  />
                  <hr
                    style={{
                      border: "1.5px solid #000000",
                      width: 311,
                      marginTop: 0,
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    <div style={{ width: 311 }}>
                      <div
                        style={{
                          marginTop: 16,
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: 16,
                        }}
                      >
                        Informasi Data Kambing
                        <hr
                          style={{
                            marginLeft: 0,
                            marginTop: 0,
                            width: 211,
                            border: "1.5px solid #000000",
                          }}
                        />
                      </div>
                      <div style={{ marginTop: 24 }}>
                        <div style={styles.textContainer}>
                          <p style={styles.textMobile}>Nomor Sertifikat</p>
                          <p style={styles.textValueMobile}>
                            : {this.state.data.code}
                          </p>
                        </div>
                        <div style={styles.textContainer}>
                          <p style={styles.textMobile}>Nama Kambing</p>
                          <p style={styles.textValueMobile}>
                            : {this.state.data?.goat?.full_name}
                          </p>
                        </div>
                        <div style={styles.textContainer}>
                          <p style={styles.textMobile}>Ident</p>
                          <p style={styles.textValueMobile}>
                            : {this.state.data?.goat?.identity_tag}
                          </p>
                        </div>
                        <div style={styles.textContainer}>
                          <p style={styles.textMobile}>Tatto</p>
                          <p style={styles.textValueMobile}>: -</p>
                        </div>
                        <div style={styles.textContainer}>
                          <p style={styles.textMobile}>Sex</p>
                          <p
                            style={{
                              ...styles.textValueMobile,
                              textTransform: "capitalize",
                            }}
                          >
                            : {this.state.data?.goat?.gender}
                          </p>
                        </div>
                        <div style={styles.textContainer}>
                          <p style={styles.textMobile}>Grade</p>
                          <p style={styles.textValueMobile}>
                            : {this.state.data?.goat?.grade?.name}
                          </p>
                        </div>
                        <div style={styles.textContainer}>
                          <p style={styles.textMobile}>Colour</p>
                          <p style={styles.textValueMobile}>
                            : {this.state.data?.goat?.color?.name}
                          </p>
                        </div>
                        <div style={styles.textContainer}>
                          <p style={styles.textMobile}>Birth Weight</p>
                          <p style={styles.textValueMobile}>
                            : {this.state.data?.goat?.weight} Kg
                          </p>
                        </div>
                        <div style={styles.textContainer}>
                          <p style={styles.textMobile}>Birth Type</p>
                          <p style={styles.textValueMobile}>
                            : {this.state.data?.goat?.goat_birth_type?.name}
                          </p>
                        </div>
                        <div style={styles.textContainer}>
                          <p style={styles.textMobile}>BREEDER (PFA)</p>
                          <p style={styles.textValueMobile}>: -</p>
                        </div>
                        {this.state.goat_owner.map((item) => {
                          return (
                            <>
                              <div style={styles.textContainer}>
                                <p style={styles.textMobile}>OWNER (PFA)</p>
                                <p style={styles.textValueMobile}>
                                  : {item.owner.name}
                                </p>
                              </div>
                            </>
                          );
                        })}
                      </div>

                      <div
                        style={{
                          marginTop: 48,
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: 16,
                        }}
                      >
                        Foto Kambing
                        <hr
                          style={{
                            marginLeft: 0,
                            width: 211,
                            border: "1.5px solid #000000",
                          }}
                        />
                        <div style={{ marginTop: 33 }}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <div style={
                              !this.state.image_father
                                ? styles.imageNotFoundMobile
                                : null
                            }>
                              <img
                                style={{
                                  width: this.state.image_father ? 150 : 138,
                                  height: 112,
                                  margin: "8px 18px",
                                }}
                                src={
                                  this.state.image_father
                                    ? this.state.image_father
                                    : `/images/no-image.png`
                                }
                              />
                              <p style={{ textAlign: "center" }}>Shire</p>
                            </div>

                            <div style={
                              !this.state.image_mother
                                ? styles.imageNotFoundMobile
                                : null
                            }>
                              <img
                                style={{
                                  width: this.state.image_mother ? 150 : 138,
                                  height: 112,
                                  margin: "8px 18px",
                                }}
                                src={
                                  this.state.image_mother
                                    ? this.state.image_mother
                                    : `/images/no-image.png`
                                }
                              />
                              <p style={{ textAlign: "center" }}>Dam</p>
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <div style={
                              !this.state.image_front
                                ? styles.imageNotFoundMobile
                                : null
                            }>
                              <img
                                style={{
                                  width: this.state.image_front ? 150 : 138,
                                  height: 112,
                                  margin: "8px 18px",
                                }}
                                src={
                                  this.state.image_front
                                    ? this.state.image_front
                                    : `/images/no-image.png`
                                }
                              />
                              <p style={{ textAlign: "center" }}>Front</p>
                            </div>

                            <div style={
                              !this.state.image_back
                                ? styles.imageNotFoundMobile
                                : null
                            }>
                              <img
                                style={{
                                  width: this.state.image_back ? 138 : 70,
                                  height: 112,
                                  margin: "8px 18px",
                                }}
                                src={
                                  this.state.image_back
                                    ? this.state.image_back
                                    : `/images/no-image.png`
                                }
                              />
                              <p style={{ textAlign: "center" }}>Back</p>
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <div style={
                              !this.state.image_right
                                ? styles.imageNotFoundMobile
                                : null
                            }>
                              <img
                                style={{
                                  width: this.state.image_right ? 150 : 138,
                                  height: 112,
                                  margin: "8px 18px",
                                }}
                                src={
                                  this.state.image_right
                                    ? this.state.image_right
                                    : `/images/no-image.png`
                                }
                              />
                              <p style={{ textAlign: "center" }}>Right</p>
                            </div>

                            <div style={
                              !this.state.image_left
                                ? styles.imageNotFoundMobile
                                : null
                            }>
                              <img
                                style={{
                                  width: this.state.image_left ? 150 : 138,
                                  height: 112,
                                  margin: "8px 18px",
                                }}
                                src={
                                  this.state.image_left
                                    ? this.state.image_left
                                    : `/images/no-image.png`
                                }
                              />
                              <p style={{ textAlign: "center" }}>Left</p>
                            </div>
                          </div>

                          <p style={{ textAlign: "center", marginTop: 24 }}>
                            Cetak Kartu Kambing
                          </p>
                          <Link
                            to={`${RoutePath.GOAT_CARD.replace(
                              ":id",
                              this.state.data?.goat_id
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <input
                              type="submit"
                              style={{
                                background: "#1C7406",
                                boxShadow: "0px 8px 8px #D8DDD7",
                                borderRadius: 6,
                                width: 199,
                                height: 48,
                                color: "white",
                                marginTop: 10,
                                cursor: "pointer",
                                marginBottom: 24,
                              }}
                              value="Cetak Kartu"
                            />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default LandingPageQR;

const styles = {
  imageNotFound: { width: 422, padding: "0px 50px", margin: "0px 25px" },
  imageNotFoundMobile: { width: 422 },
  text: {
    flex: 1,
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: 20,
    lineHeight: "160%",
    letterSpacing: "0.015em",
  },
  textValue: {
    flex: 2,
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: 20,
    lineHeight: "160%",
    letterSpacing: "0.015em",
  },
  textMobile: {
    flex: 1,
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: 12,
    letterSpacing: "0.015em",
  },
  textValueMobile: {
    flex: 2,
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: 12,
    letterSpacing: "0.015em",
  },
  textContainer: {
    display: "flex",
  },
};
